import { styled } from '@elliemae/ds-system';

export const LoaderBox = styled.div`
  position: absolute;
  width: 100%;
  z-index: 10;
  background-color: white;
  height: 50px;
  bottom: -50px;
  border-top: 1px solid #e0e3e8;
  align-items: center;
  transition: 400ms cubic-bezier(0, 0, 0.42, 1);
  &.opened {
    transition: 400ms cubic-bezier(0.36, 0, 1, 1);
    bottom: 0;
  }
`;
